import { render, staticRenderFns } from "./FViewHeading.vue?vue&type=template&id=0727415c&"
import script from "./FViewHeading.vue?vue&type=script&lang=js&"
export * from "./FViewHeading.vue?vue&type=script&lang=js&"
import style0 from "./FViewHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports